import { createContext, useContext, type ReactNode } from 'react';
import { DaghfalClient } from '../api/client';

const ApiContext = createContext<DaghfalClient | null>(null);

export function ApiProvider({ client, children }: { client: DaghfalClient; children: ReactNode }) {
  return <ApiContext.Provider value={client}>{children}</ApiContext.Provider>;
}

/**
 * Resolves the API's media links (see `DaghfalClient.mediaUrl`).
 *
 * Works outside an `<ApiProvider>` too, returning links as they are, so a component that shows media can be
 * rendered on its own in a test.
 */
export function useMediaUrl(): (url: string | null | undefined) => string | undefined {
  const client = useContext(ApiContext);
  return (url) => (client ? client.mediaUrl(url) : url ?? undefined);
}

export function useApi(): DaghfalClient {
  const client = useContext(ApiContext);
  if (!client) throw new Error('useApi was called outside an <ApiProvider>.');
  return client;
}
